import { ChangeDetectionStrategy, Component, HostListener, ViewChild } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { DeviceService } from '@frontend/vanilla/core';
import { NgxPopperjsContentComponent, NgxPopperjsPlacements } from 'ngx-popperjs';

@Component({
    selector: 'ms-multi-builder-onboarding',
    templateUrl: 'multi-builder-onboarding.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MultiBuilderOnBoardingComponent {
    @ViewChild('onBoardingContent') onBoardingPopper: NgxPopperjsContentComponent;

    constructor(
        public sitecore: Sitecore,
        private deviceService: DeviceService,
    ) {}

    @HostListener('window:scroll', [])
    scroll(): void {
        if (this.deviceService.isMobilePhone) {
            this.dismiss();
        }
    }

    dismiss(): void {
        if (this.onBoardingPopper) {
            this.onBoardingPopper.hide();
        }
    }

    protected readonly NgxPopperjsPlacements = NgxPopperjsPlacements;
}
